module.exports = __webpack_public_path__ + "static/redux-5c4571a2fa1dbabf5da105be189e8c2c.gif";